import {
    createElementVNode as _$ce,
    createTextVNode as _$ct,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {XMarkdown, Switch} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'span', [
                _$ct('enableMermaid: '),
                _$cc(Switch, {
                    'value': this.get('enableMermaid'),
                    'ev-$change:value': this.setEnableMermaid
                })
            ], 4),
            _$ce(2, 'span', [
                _$ct('brandTheme: '),
                _$cc(Switch, {
                    'value': this.get('brandTheme'),
                    'ev-$change:value': this.setBrandTheme
                })
            ], 4)
        ], 4, 'xmarkdown-demo-mermaid-actions'),
        _$cc(XMarkdown, {
            'content': this.get('content'),
            'enableMermaid': this.get('enableMermaid'),
            'mermaidConfig': this.getMermaidConfig()
        })
    ], 4, 'xmarkdown-demo-mermaid');
};